import { Box, Snackbar } from "@mui/material";
import AlertComponent from "../AlertComponent/AlertComponent";
import { useTranslation } from "react-i18next";
import { SnackbarData } from "../../../core/models/snackbar/snackbar.model";

interface SnackbarComponentProps {
  snackbarData: SnackbarData;
  setSnackbarData: React.Dispatch<React.SetStateAction<SnackbarData>>;
  autoHideDuration?: number;
}

const SnackbarComponent = ({
  snackbarData,
  setSnackbarData,
  autoHideDuration = 3000,
}: SnackbarComponentProps) => {
  const { t } = useTranslation();
  const { isOpen, isSuccessSeverity, text } = snackbarData;

  return (
    <Snackbar
      open={isOpen}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      autoHideDuration={autoHideDuration}
      onClose={() => {
        setSnackbarData((prevSnackbarData) => ({
          ...prevSnackbarData,
          isOpen: false,
        }));
      }}
    >
      <Box component="div">
        <AlertComponent
          success={isSuccessSeverity}
          onClick={() =>
            setSnackbarData((prevSnackbarData) => ({
              ...prevSnackbarData,
              isOpen: false,
            }))
          }
        >
          {t(text)}
        </AlertComponent>
      </Box>
    </Snackbar>
  );
};

export default SnackbarComponent;
